<template lang="html">
  <b-modal ref="licenseagreement" size="lg" centered lno-close-on-esc no-close-on-backdrop hide-header-close title="StrinGnosis® Online Software as a Service User Agreement">

    <div class="modal-scroll-container">

      <!-- license agreemnet html content starts here -->
      <div class=Section1>

      <p class=Normal style='line-height:normal'><b><span style='font-size:10.0pt'>VERSION
      DATE: November 9, 2020</span></b></p>

      <p class=Normal align=center style='text-align:center;line-height:normal'><b><span
      style='font-size:10.0pt'>StrinGnosis®</span></b><span style='font-size:10.0pt'>
      <b>Software as a Service Agreement</b></span></p>

      </div>

      <b><span style='font-size:10.0pt;font-family:"Calibri",sans-serif'><br
      clear=all style='page-break-before:auto'>
      </span></b>

      <div class=Section1>

      <p class=Normal style='line-height:normal'><b><span style='font-size:10.0pt; border:solid 1.0pt' >IMPORTANT:</span></b><span
      style='font-size:10.0pt'>  Carefully read the following terms and conditions in
      this StrinGnosis® Software as a Service Agreement (the “<b>Agreement</b>”).  This
      is a legal agreement between you on behalf of your sole proprietorship, limited
      liability company, corporation, government, or any other Person that you
      represent (“<b>Customer</b>”), and Blade Technology Corporation, LLC (“<b>Blade
      Technology</b>”), a Delaware, U.S.A. limited liability company, with its
      principal offices located at 16285 Park Ten Place, Suite 600, Houston, Texas
      77084, U.S.A., who are the sole parties to this Agreement.  By using the
      Services, Customer agrees to all of the terms of this Agreement and represents
      that he, she, or it has the full right and authority to execute this Agreement
      on behalf of his or her sole proprietorship, limited liability company,
      partnership, corporation, government, or any Person that he, she, or it
      represents.  If the individual executing this Agreement has any kind of
      responsibility for the Customer, then that individual is to be deemed to have apparent
      authority to execute this Agreement.  Please carefully read the Agreement
      below.  <b><span style='text-transform:uppercase;letter-spacing:1.0pt'>This
      Agreement contains provisions relating to indemnity, release of liability, and
      allocation of risk including requiring one party (the Indemnitor) to be
      responsible for the negligence, strict liability, or other fault of another
      party (the Indemnitee)</span></b>.  If Customer does not agree to all of the
      terms of this Agreement, Customer will not use the Services.  Customer and Blade
      Technology expressly find contractual consideration for this Agreement in the
      act of Blade Technology providing the right to use the Services to Customer,
      and Customer accepting the right to use the Services under the terms of this
      Agreement.</span></p>

      </div>

      <b><span style='font-size:11.0pt;font-family:"Calibri",sans-serif'><br
      clear=all style='page-break-before:auto'>
      </span></b>

      <div class=Section3>

      <p class=Normal align=center style='text-align:center;line-height:normal'><a
      name="_PaperSoftwareContractToolsAnalysisRange"><b><span style='font-size:9.0pt'>Recitals</span></b></a></p>

      <p class=Normal style='line-height:normal'><span style='font-size:9.0pt'>Blade
      Technology provides access to its StrinGnosis software-as-a-service offerings
      to its customers;</span></p>

      <p class=Normal style='line-height:normal'><span style='font-size:9.0pt'>Customer
      desires to access certain StrinGnosis software-as-a-service offerings described
      herein, and Blade Technology desires to provide Customer access to such
      offerings, subject to the terms stated in this Agreement.</span></p>

      <p class=Normal style='line-height:normal'><span style='font-size:9.0pt'>The
      parties therefore agree as follows:<a name="co_anchor_a1030081_1"></a></span></p>

      <h1 class="Heading1"><span style='font-size:9.0pt;color:#010000;font-weight:normal'>1<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Definitions.<a
      name="co_anchor_a672008_1"></a></span></h1>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Access Credentials</b>” means
      any user name, identification number, password, license or security key,
      security token, PIN, or other security code, method, technology, or device
      used, alone or in combination, to verify an individual’s identity and
      authorization to access and use the Services.<a name="co_anchor_a953540_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Action</b>” means any claim,
      action, cause of action, demand, lawsuit, arbitration, inquiry, audit, notice
      of violation, proceeding, litigation, citation, summons, subpoena, or
      investigation of any nature, civil, criminal, administrative, regulatory, or
      other, whether at law, in equity, or otherwise.<a name="co_anchor_a1063351_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Affiliate</b>” of a Person
      means any other Person that directly or indirectly, through one or more
      intermediaries, controls, is controlled by, or is under common control with,
      such Person.<a name="co_anchor_a639737_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Agreement</b>” has the meaning
      stated in the preamble.<a name="co_anchor_a558331_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(e)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Authorized User</b>” means
      Customer’s employees, consultants, contractors, and agents (a) who are
      authorized by Customer to access and use the Services under the rights granted
      to Customer in accordance with this Agreement; and (b) for whom access to the
      Services has been provided to hereunder<a name="co_anchor_a266488_1"></a>.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(f)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Blade Technology</b>” has the
      meaning stated in the preamble<a name="co_anchor_a807008_1"></a>.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(g)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Blade Technology Disabling
      Device</b>” means any software, hardware, or other technology, device, or means
      (including any back door, time bomb, time out, drop dead device, software
      routine, or other disabling device) used by Blade Technology or its designee to
      disable Customer’s or any Authorized User’s access to or use of the Services
      automatically with the passage of time or under the positive control of Blade
      Technology or its designee.<a name="co_anchor_a954808_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(h)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Blade Technology Indemnitee</b>”
      has the meaning stated in Section 12<a name="co_anchor_a221842_1"></a>(b)</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(i)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Blade Technology Materials</b>”
      means the Services, specifications, Documentation, and Blade Technology Systems
      and any and all other information, data, documents, materials, works, and other
      content, devices, methods, processes, hardware, software, and other
      technologies and inventions, including any deliverables, technical or
      functional descriptions, requirements, plans, or reports, that are provided or
      used by Blade Technology or any Subcontractor in connection with the Services
      or otherwise comprise or relate to the Services or Blade Technology Systems.
      For the avoidance of doubt, Blade Technology Materials include Resultant Data
      and any information, data, or other content derived from Blade Technology’s
      monitoring of Customer’s access to or use of the Services, but do not include
      Customer Data.<a name="co_anchor_a420742_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(j)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Blade Technology Personnel</b>”
      means all individuals involved in the performance of Services as employees,
      agents, or independent contractors of Blade Technology or any Subcontractor.<a
      name="co_anchor_a837314_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(k)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Blade Technology Systems</b>”
      means the information technology infrastructure used by or on behalf of Blade
      Technology in performing the Services, including all computers, software,
      hardware, databases, electronic systems (including database management
      systems), and networks, whether operated directly by Blade Technology or
      through the use of third-party services.<a name="co_anchor_a574326_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(l)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Confidential Information</b>”
      has the meaning stated in Section <a name="co_anchor_a430155_1"></a>9(a).</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(m)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Customer</b>” has the meaning
      stated in the preamble of this Agreement.<a name="co_anchor_a543605_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(n)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Customer Data</b>” means
      information, data, and other content, in any form or medium, that is collected,
      downloaded, or otherwise received, directly or indirectly from Customer or an
      Authorized User by or through the Services. For the avoidance of doubt,
      Customer Data does not include Resultant Data or any other information
      reflecting the access or use of the Services by or on behalf of Customer or any
      Authorized User.<a name="co_anchor_a836864_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(o)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Customer Failure</b>” has the
      meaning stated in Section 4<a name="co_anchor_a775759_1"></a>(b).</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(p)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Customer Indemnitee</b>” has
      the meaning stated in Section 12(a).<a name="co_anchor_a661099_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(q)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Customer Systems</b>” means the
      Customer’s information technology infrastructure, including computers,
      software, hardware, databases, electronic systems (including database
      management systems), and networks, whether operated directly by Customer or
      through the use of third-party services.<a name="co_anchor_a850772_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(r)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Disclosing Party</b>” has the
      meaning stated in Section 9<a name="co_anchor_a978948_1"></a>(a)</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(s)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Documentation</b>” means any
      manuals, instructions, or other documents or materials that the Blade
      Technology provides or makes available to Customer in any form or medium and
      which describe the functionality, components, features, or requirements of the
      Services or Blade Technology Materials, including any aspect of the
      installation, configuration, integration, operation, use, support, or
      maintenance thereof.<a name="co_anchor_a366068_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(t)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Effective Date</b>” the start
      date for the Services as agreed between the parties in writing before use of
      the Services.<a name="co_anchor_a983598_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(u)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Evaluation Period</b>” has the
      meaning stated in Section 3(a).</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(v)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Fees</b>” has the meaning
      stated in Section 8<a name="co_anchor_a205848_1"></a>(a).</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(w)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Force Majeure Event</b>” has
      the meaning stated in Section 15<a name="co_anchor_a216529_1"></a>(i)(1).</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(x)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Harmful Code</b>” means any
      software, hardware, or other technology, device, or means, including any virus,
      worm, malware, or other malicious computer code, the purpose or effect of which
      is to (a) permit unauthorized access to, or to destroy, disrupt, disable,
      distort, or otherwise harm or impede in any manner any (i) computer, software,
      firmware, hardware, system, or network; or (ii) any application or function of
      any of the foregoing or the security, integrity, confidentiality, or use of any
      data Processed thereby; or (b) prevent Customer or any Authorized User from
      accessing or using the Services or Blade Technology Systems as intended by this
      Agreement. Harmful Code does not include any Blade Technology Disabling Device.<a
      name="co_anchor_a601875_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(y)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Indemnitee</b>” has the meaning
      stated in Section 12<a name="co_anchor_a356204_1"></a>(c).</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(z)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Indemnitor</b>” has the meaning
      stated in Section 12<a name="co_anchor_a642459_1"></a>(c).</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(aa)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“</span><b><span style='font-size:
      9.0pt'>Initial Term</span></b><span style='font-size:9.0pt'>” has the meaning
      stated in Section 14(a).</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(bb)<span style='font:7.0pt "Times New Roman"'>&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Intellectual Property Rights</b>”
      means any and all registered and unregistered rights granted, applied for, or
      otherwise now or hereafter in existence under or related to any patent,
      copyright, trademark, trade secret, database protection, or other intellectual
      property rights laws, and all similar or equivalent rights or forms of
      protection, in any part of the world.<a name="co_anchor_a1008215_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(cc)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Law</b>” means any statute,
      law, ordinance, regulation, rule, code, order, constitution, treaty, common
      law, judgment, decree, or other requirement of any federal, state, local, or
      foreign government or political subdivision thereof, or any arbitrator, court,
      or tribunal of competent jurisdiction.<a name="co_anchor_a1061622_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(dd)<span style='font:7.0pt "Times New Roman"'>&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Losses</b>” both mean any and
      all losses, damages, deficiencies, claims, actions, judgments, settlements,
      interest, awards, penalties, fines, costs, or expenses of whatever kind,
      including reasonable attorneys’ fees and the costs of enforcing any right to
      indemnification hereunder and the cost of pursuing any insurance providers.<a
      name="co_anchor_a531601_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(ee)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Person</b>” means an
      individual, corporation, partnership, joint venture, limited liability entity,
      governmental authority, unincorporated organization, trust, association, or
      other entity.<a name="co_anchor_a843945_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(ff)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Personal Information</b>” means
      any information that does or can identify a specific individual or by or from
      which a specific individual may be identified, contacted, or located.<a
      name="co_anchor_a862195_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(gg)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Process</b>” means to take any
      action or perform any operation or set of operations that the Services are
      capable of taking or performing on any data, information, or other content,
      including to collect, receive, input, upload, download, record, reproduce,
      store, organize, compile, combine, log, catalog, cross-reference, manage,
      maintain, copy, adapt, alter, translate, or make other derivative works or
      improvements, process, retrieve, output, consult, use, perform, display, disseminate,
      transmit, submit, post, transfer, disclose, or otherwise provide or make
      available, or block, erase, or destroy. “<b>Processing</b>” and “<b>Processed</b>”
      have correlative meanings.<a name="co_anchor_a866767_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(hh)<span style='font:7.0pt "Times New Roman"'>&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Prohibited Data</b>” has the
      meaning stated in Section 7(b).</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(ii)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Receiving Party</b>” has the
      meaning stated in Section 9<a name="co_anchor_a527556_1"></a>(a).</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(jj)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Reimbursable Expenses</b>” has
      the meaning stated in Section 8(g).<a name="co_anchor_a1022941_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(kk)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“</span><b><span style='font-size:
      9.0pt'>Renewal Term</span></b><span style='font-size:9.0pt'>” has the meaning
      stated in Section 14(b).</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(ll)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Representatives</b>” means,
      with respect to a party, that party’s and its Affiliates’ employees, officers,
      directors, consultants, agents, independent contractors, service providers,
      subcontractors, and legal advisors.<a name="co_anchor_a736852_1"></a></span></h2>

      <h2 class="Heading2" style='margin-left:40.5pt;text-indent:-22.5pt'><span style='font-size:9.0pt;
      color:#010000'>(mm)<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><span
      style='font-size:9.0pt'>“<b>Resultant Data</b>” means data and information
      related to Customer’s use of the Services that is used by Blade Technology in
      an aggregate and anonymized manner, including to compile statistical and
      performance information related to the provision and operation of the Services.<a
      name="co_anchor_a189328_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(nn)<span style='font:7.0pt "Times New Roman"'>&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Services</b>” means the
      software-as-a-service offerings described in Exhibit A.<a
      name="co_anchor_a230753_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(oo)<span style='font:7.0pt "Times New Roman"'>&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Subcontractor</b>” has the
      meaning stated in Section 2(f).<a name="co_anchor_a185303_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(pp)<span style='font:7.0pt "Times New Roman"'>&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Support Services</b>” has the
      meaning stated in Section 5<a name="co_anchor_a508467_1"></a>.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(qq)<span style='font:7.0pt "Times New Roman"'>&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Term</b>” has the meaning
      stated <a name="co_anchor_a544556_1"></a>in Section 14(a).</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(rr)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<b>Third-Party Materials</b>” means
      materials and information, in any form or medium, including any open-source or
      other software, documents, data, content, specifications, products, equipment,
      or components of or relating to the Services that are not proprietary to Blade
      Technology.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(ss)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>“<a name="co_anchor_a557828_1"></a><b>U.S.
      Export Laws</b>” has the meaning stated in Section 15(o)(1).</span></h2>

      <p class=Normal style='line-height:normal'><span style='font-size:9.0pt'>Any
      defined terms not shown under this Section are as defined under this Agreement.</span></p>

      <h1 class="Heading1"><span style='font-size:9.0pt;color:#010000;font-weight:normal'>2<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Services.<a
      name="co_anchor_a662051_1"></a></span></h1>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Access and Use. Subject to and
      conditioned on Customer’s and its Authorized Users’ compliance with the terms
      of this Agreement and all applicable Laws, Blade Technology hereby grants
      Customer a non-exclusive, non-transferable (except in compliance with Section
      15(h)) right to access and use the Services during the Term, solely for use by
      Authorized Users in accordance with the terms in this Agreement and all
      applicable Laws.  Blade Technology shall provide to Customer the Access
      Credentials within a reasonable time following the Effective Date. The total
      number of Authorized Users will not exceed the number agreed to in writing
      between the parties before use of the Services, except as expressly agreed to
      in writing by the parties and subject to any appropriate adjustment of the Fees
      payable hereunder.</span></h2>

      <h2 class="Heading2"><a name="co_anchor_a749642_1"></a><span style='font-size:9.0pt;color:#010000'>(b)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
      style='font-size:9.0pt'>Documentation License. Blade Technology hereby grants
      to Customer a non-exclusive, non-sublicensable, non-transferable (except in
      compliance with Section 15(h)) license to use the Documentation during the Term
      solely for Customer’s business purposes in connection with its use of the
      Services.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Service and System Control. Except
      as otherwise expressly provided in this Agreement, as between the parties:<a
      name="co_anchor_a162170_1"></a></span></h2>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(1)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Blade Technology has and will
      retain sole control over the operation, provision, maintenance, and management
      of the Blade Technology Materials; and<a name="co_anchor_a190168_1"></a></span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(2)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Customer has and will retain sole
      control over the operation, maintenance, and management of, and all access to
      and use of, the Customer Systems, and sole responsibility for all access to and
      use of the Blade Technology Materials by any Person by or through the Customer
      Systems or any other means controlled by Customer or any Authorized User,
      including any:</span></h3>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(A)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>information, instructions, or
      materials provided by any of them to the Services or Blade Technology; </span></h4>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(B)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>results obtained from any use of
      the Services or Blade Technology Materials; and </span></h4>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(C)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>conclusions, decisions, or actions
      based on such use.<a name="co_anchor_a706917_1"></a></span></h4>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Reservation of Rights. Nothing in
      this Agreement grants any right, title, or interest in or to (including any
      license under) any Intellectual Property Rights in or relating to, the
      Services, Blade Technology Materials, or Third-Party Materials, whether
      expressly, by implication, estoppel, or otherwise. All right, title, and
      interest in and to the Services, the Blade Technology Materials, and the
      Third-Party Materials are and will remain with Blade Technology and the
      respective rights holders in the Third-Party Materials.<a
      name="co_anchor_a1027357_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(e)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Changes. Blade Technology reserves
      the right, in its sole discretion, to make any changes to the Services and Blade
      Technology Materials that it deems necessary or useful to maintain or enhance:
      the quality or delivery of Blade Technology’s services to its customers, the
      competitive strength of or market for Blade Technology’s services, or the
      Services’ cost efficiency or performance; or to comply with any applicable Law. 
      Without limiting the foregoing, either party may, at any time during the Term,
      request in writing changes to the Services. The parties shall evaluate and, if
      agreed, implement all such requested changes. No requested changes will be
      effective unless and until memorialized in a written order signed by the
      authorized signatories of both parties.<a name="co_anchor_a918402_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(f)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Subcontractors. Blade Technology
      may from time to time in its discretion engage third parties to perform
      Services (each, a “<b>Subcontractor</b>”).<a name="co_anchor_a134171_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(g)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Suspension or Termination of
      Services. Blade Technology may, directly or indirectly, and by use of a Blade
      Technology Disabling Device or any other lawful means, suspend, terminate, or
      otherwise deny Customer’s, any Authorized User’s, or any other Person’s access
      to or use of all or any part of the Services or Blade Technology Materials,
      without incurring any resulting obligation or liability, if: (a) Blade
      Technology receives a judicial or other governmental demand or order, subpoena,
      or law enforcement request that expressly or by reasonable implication requires
      Blade Technology to do so; (b) at any time and for any reason during the
      Evaluation Period; (c) any breach of Section 3(a) or Section 3(b); (d) Blade
      Technology believes, in its sole discretion, that: (i) Customer or any
      Authorized User has failed to comply with any term of this Agreement, or
      accessed or used the Services beyond the scope of the rights granted or for a
      purpose not authorized under this Agreement or in any manner that does not
      comply with any instruction or requirement of the specifications; (ii) Customer
      or any Authorized User is, has been, or is likely to be involved in any fraudulent,
      misleading, or unlawful activities relating to or in connection with any of the
      Services; or (iii) this Agreement expires or is terminated. This Section 2(g) does
      not limit any of Blade Technology’s other rights or remedies, whether at law,
      in equity, or under this Agreement.<a name="co_anchor_a766087_1"></a></span></h2>

      <h1 class="Heading1"><span style='font-size:9.0pt;color:#010000;font-weight:normal'>3<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Evaluation Period Use; Academic and
      Educational Use; General Use Restrictions; Service Usage and Data Storage.<a
      name="co_anchor_a1063376_1"></a></span></h1>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Evaluation Period Use. Subject to all
      other terms of this Agreement, Blade Technology may allow Customer to test and evaluate
      the Services at Blade Technology’s sole discretion, which provides Customer the
      ability to evaluate the Services for a limited period and at no cost (the “</span><b><span
      style='font-size:9.0pt'>Evaluation Period</span></b><span style='font-size:
      9.0pt'>”).  During the Evaluation Period, Customer shall only access and use
      the Services and Blade Technology Materials for evaluation and testing purposes
      and not for production use.  Customer acknowledges that Blade Technology makes
      the Evaluation Period available to Customer solely to permit Customer to
      determine whether the Services operate to Customer’s satisfaction and meet
      Customer’s requirements.  Evaluation and testing purposes do not include, and Customer
      shall not access or use the Services or Blade Technology Materials during the
      Evaluation Period for the development or implementation of activities required
      or contemplated as part of Customer’s operations or activities or both.  Customer
      acknowledges that Customer will not have access to or any right to access the
      Services after the end of the Evaluation Period.  Customer shall not access the
      Services after the end of the Evaluation Period.  At the end of the Evaluation
      Period, Customer’s evaluation rights to use the Services are automatically
      terminated, unless those evaluation rights are extended by Blade Technology at
      Blade Technology’s sole discretion.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Academic and Educational Use. Subject
      to all other terms of this Agreement, Blade Technology may allow Customer to access
      or use the Services and Blade Technology Materials solely for academic and
      educational purposes and at Blade Technology’s sole discretion.  When Customer
      is accessing or using the Services or Blade Technology Materials or both for academic
      and educational purposes, Customer shall limit that access and use for the
      purposes directly related to teaching, training, degree-granting programs, and
      research and development that is part of the instructional function performed by
      Customer.  An academic and educational purpose does not include, and Customer
      shall not access and use the Services or Blade Technology Materials or both for
      any one or more of the following:</span></h2>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(1)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>for any commercial purpose, including,
      without limitation, developing software for sale, license, or subscription or
      providing services to anyone that is not for academic and educational purposes
      as defined in this Section 3; or</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(2)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>research and development if the
      results of that research and development are primarily intended to benefit a
      third party, unless such results are publicly available at a cost to the user of
      no more than reproduction and shipping charges.</span></h3>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>General Use Restrictions. Customer
      shall not, and shall not permit any other Person to, access or use the Services
      or Blade Technology Materials at any time and for any reason except as
      expressly permitted by this Agreement and, in the case of Third-Party
      Materials, the applicable third-party license agreement. For purposes of
      clarity and without limiting the generality of the foregoing, Customer shall
      not, except as this Agreement expressly permits:</span></h2>

      <h3 class="Heading3"><a name="co_anchor_a290345_1"></a><span style='font-size:9.0pt;color:#010000'>(1)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>copy, modify, or create derivative
      works or improvements of the Services or Blade Technology Materials;</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(2)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>rent, lease, lend, sell,
      sublicense, assign, distribute, publish, transfer, or otherwise make available
      any Services or Blade Technology Materials to any Person, including on or in
      connection with the internet or any time-sharing, service bureau, software as a
      service, cloud, or other technology or service;</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(3)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>reverse engineer, disassemble,
      decompile, decode, adapt, or otherwise attempt to derive or gain access to the
      source code of the Services or Blade Technology Materials, in whole or in part;</span></h3>

      <h3 class="Heading3"><a name="co_anchor_a835093_1"></a><span style='font-size:9.0pt;color:#010000'>(4)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>bypass or breach any security
      device or protection used by the Services or Blade Technology Materials or
      access or use the Services or Blade Technology Materials other than by an
      Authorized User through the use of his or her own then valid Access
      Credentials;</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(5)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>input, upload, transmit, or
      otherwise provide to or through the Services or Blade Technology Systems, any
      information or materials that are unlawful or injurious, or contain, transmit,
      or activate any Harmful Code;</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(6)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>damage, destroy, disrupt, disable,
      impair, interfere with, or otherwise impede or harm in any manner the Services,
      Blade Technology Systems, or Blade Technology’s provision of services to any
      third party, in whole or in part;</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(7)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>remove, delete, alter, or obscure
      any trademarks, specifications, Documentation, EULA, warranties, or
      disclaimers, or any copyright, trademark, patent, or other intellectual
      property or proprietary rights notices from any Services or Blade Technology Materials,
      including any copy thereof;</span></h3>

      <h3 class="Heading3"><a name="co_anchor_a279664_1"></a><span style='font-size:9.0pt;color:#010000'>(8)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>access or use the Services or Blade
      Technology Materials in any manner or for any purpose that infringes,
      misappropriates, or otherwise violates any Intellectual Property Right or other
      right of any third party (including by any unauthorized access to,
      misappropriation, use, alteration, destruction, or disclosure of the data of
      any other Blade Technology customer), or that violates any applicable Law;</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(9)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>access or use the Services or Blade
      Technology Materials for purposes of competitive analysis of the Services or Blade
      Technology Materials, the development, provision, or use of a competing
      software service or product or any other purpose that is to the Blade
      Technology’s detriment or commercial disadvantage; or</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(10)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>otherwise access or use the
      Services or Blade Technology Materials beyond the scope of the authorization
      granted under this Section 3<a name="co_anchor_a634548_1"></a>.</span></h3>

      <h1 class="Heading1"><span style='font-size:9.0pt;color:#010000;font-weight:normal'>4<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Customer Obligations.</span></h1>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Customer Systems and Cooperation.
      Customer shall at all times during the Term: (a) set up, maintain, and operate
      in good repair and in accordance with the specifications all Customer Systems
      on or through which the Services are accessed or used; (b) provide Blade
      Technology Personnel with such access to Customer’s premises and Customer
      Systems as is necessary for Blade Technology to perform the Services in
      accordance with the specifications; and (c) provide all cooperation and
      assistance as Blade Technology may reasonably request to enable Blade
      Technology to exercise its rights and perform its obligations under and in
      connection with this Agreement.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Effect of Customer Failure or
      Delay. Blade Technology is not responsible or liable for any delay or failure of
      performance caused in whole or in part by Customer’s delay in performing, or
      failure to perform, any of its obligations under this Agreement (each, a “<b>Customer
      Failure</b>”).</span></h2>

      <h2 class="Heading2"><a name="co_anchor_a471928_1"></a><span style='font-size:9.0pt;color:#010000'>(c)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
      style='font-size:9.0pt'>Corrective Action and Notice. If Customer becomes aware
      of any actual or threatened activity prohibited by Section 3, Customer shall,
      and shall cause its Authorized Users to, immediately: (a) promptly notify Blade
      Technology of any such actual or threatened activity; and (b) <a
      name="co_anchor_a894952_1"></a>take all reasonable and lawful measures within
      their respective control that are necessary to stop the activity or threatened
      activity and to mitigate its effects (including, where applicable, by
      discontinuing and preventing any unauthorized access to the Services and Blade
      Technology Materials and permanently erasing from their systems and destroying
      any data to which any of them have gained unauthorized access).</span></h2>

      <h1 class="Heading1"><a name="co_anchor_a235643_1"></a><span style='font-size:9.0pt;color:#010000;
      font-weight:normal'>5<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Support Services</span><span
      style='font-size:9.0pt;font-weight:normal'>.</span><span style='font-size:9.0pt'>
      </span><span style='font-size:9.0pt;font-weight:normal'>The Services include Blade
      Technology’s technical customer support services (“</span><span
      style='font-size:9.0pt'>Support Services</span><span style='font-size:9.0pt;
      font-weight:normal'>”) as discussed and agreed to in writing between the
      parties before use of the Services.  If Support Services are not agreed to in
      writing before use of the Services, Blade Technology will have no obligation
      greater than helping the Customer log into the Services in order fulfill Blade
      Technology’s Support Services under this Agreement.</span></h1>

      <h1 class="Heading1"><span style='font-size:9.0pt;color:#010000;font-weight:normal'>6<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Data Backup.</span><span
      style='font-size:9.0pt;font-weight:normal'> The Services do not replace the
      need for Customer to maintain regular data backups or redundant data archives. 
      Customer acknowledges that no Blade Technology Indemnitees have any obligation
      or liability to any Customer Indemnitee for any loss, alteration, destruction,
      damage, corruption, or recovery of Customer Data.</span></h1>

      <h1 class="Heading1"><span style='font-size:9.0pt;color:#010000;font-weight:normal'>7<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Security.</span></h1>

      <h2 class="Heading2"><a name="co_anchor_a777772_1"></a><span style='font-size:9.0pt;color:#010000'>(a)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
      style='font-size:9.0pt'>Blade Technology Systems and Security Obligations.
      Blade Technology will employ security measures in accordance with applicable
      industry practice.</span></h2>

      <h2 class="Heading2"><a name="co_anchor_a1026034_1"></a><a name="co_anchor_a742967_1"></a><span
      style='font-size:9.0pt;color:#010000'>(b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Prohibited Data. Customer
      acknowledges that the Services are not designed with security and access
      management for Processing the following categories of information: (a) Personal
      Information; (b) data that is classified or used on the U.S. Munitions list,
      including software and technical data; (c) articles, services, and related
      technical data designated as defense articles or defense services; and (d) ITAR
      (International Traffic in Arms Regulations) related data, (each of the
      foregoing, “<b>Prohibited Data</b>”). Customer shall not, and shall not permit
      any Authorized User or other Person to, provide any Prohibited Data to, or
      Process any Prohibited Data through, the Services, the Blade Technology
      Systems, or any Blade Technology Personnel. Customer is solely responsible for
      reviewing all Customer Data and shall ensure that no Customer Data constitutes
      or contains any Prohibited Data.</span></h2>

      <h2 class="Heading2"><a name="co_anchor_a325112_1"></a><span style='font-size:9.0pt;color:#010000'>(c)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
      style='font-size:9.0pt'>Customer Control and Responsibility. Customer has and
      will retain sole responsibility for: (a) all Customer Data, including its
      content and use; (b) all information, instructions, and materials provided by
      or on behalf of Customer or any Authorized User in connection with the
      Services; (c) Customer Systems; (d) the security and use of Customer’s and its
      Authorized Users’ Access Credentials; and (e) all access to and use of the
      Services and Blade Technology Materials directly or indirectly by or through
      the Customer Systems or its or its Authorized Users’ Access Credentials, with
      or without Customer’s knowledge or consent, including all results obtained
      from, and all conclusions, decisions, and actions based on, such access or use.<a
      name="co_anchor_a553464_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Access and Security. Customer shall
      employ all physical, administrative, and technical controls, screening, and
      security procedures and other safeguards necessary to: (a) securely administer
      the distribution and use of all Access Credentials and protect against any
      unauthorized access to or use of the Services; and (b) control the content and
      use of Customer Data, including the uploading or other provision of Customer
      Data for Processing by the Services.<a name="co_anchor_a661098_1"></a></span></h2>

      <h1 class="Heading1"><span style='font-size:9.0pt;color:#010000;font-weight:normal'>8<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Fees and Payment.<a
      name="co_anchor_a1039754_1"></a></span></h1>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Fees. Customer shall pay Blade
      Technology the fees agreed to in writing or otherwise invoiced by Blade
      Technology (“</span><b><span style='font-size:9.0pt'>Fees</span></b><span
      style='font-size:9.0pt'>”) in accordance with this Section 8.<a
      name="co_anchor_a864808_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Taxes. All Fees and other amounts
      payable by Customer under this Agreement are exclusive of taxes and similar
      assessments. Without limiting the foregoing, Customer is responsible for all
      sales, use, and excise taxes, and any other similar taxes, duties, and charges
      of any kind imposed by any federal, state, or local governmental or regulatory
      authority on any amounts payable by Customer hereunder, other than any taxes
      imposed on Blade Technology’s income.</span></h2>

      <h2 class="Heading2"><a name="co_anchor_a110479_1"></a><span style='font-size:9.0pt;color:#010000'>(c)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
      style='font-size:9.0pt'>Payment. Customer shall pay all Fees and Reimbursable
      Expenses within thirty (30) days after the date of the invoice therefor.  Customer
      shall make all payments hereunder in U.S. dollars by direct deposit in Blade
      Technology’s U.S. bank account as stated on Blade Technology’s invoice.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Late Payment. If Customer fails to
      make any payment in full when due then, in addition to all other remedies that
      may be available:<a name="co_anchor_a917898_1"></a></span></h2>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(1)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Blade Technology may charge interest
      on the past due amount at the rate of 1.5% per month calculated daily and
      compounded monthly or, if lower, the highest rate permitted under applicable
      Law;</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(2)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Customer shall reimburse Blade
      Technology for all costs incurred by Blade Technology in collecting any late
      payments or interest, including attorneys’ fees, court costs, and collection
      agency fees; and</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(3)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>if such failure continues for fifteen
      (15) days following written notice thereof, Blade Technology may suspend
      performance of the Services until all past due amounts and interest thereon
      have been paid, without incurring any obligation or liability to Customer or
      any other Person by reason of such suspension.<a name="co_anchor_a761537_1"></a></span></h3>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(e)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>No Deductions or Setoffs. All
      amounts payable to Blade Technology under this Agreement shall be paid by
      Customer to Blade Technology in full without any setoff, recoupment,
      counterclaim, deduction, debit, or withholding for any reason (other than any
      deduction or withholding of tax as may be required by applicable Law).</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(f)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Fee Increases. Blade Technology may
      increase Fees for any reason (1) at any time during the Term by providing thirty
      (30) day’s written notice by courier, electronic mail, or otherwise to Customer
      or (2) thirty (30) days before start of any Renewal Term by providing written
      notice by courier, electronic mail, or otherwise to Customer before the start
      of the Renewal Term.</span></h2>

      <h2 class="Heading2"><a name="co_anchor_a828719_1"></a><span style='font-size:9.0pt;color:#010000'>(g)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
      style='font-size:9.0pt'>Reimbursable Expenses. Customer shall reimburse Blade
      Technology at cost plus 10% for out-of-pocket expenses incurred by Blade
      Technology in connection with performing the Services (“<b>Reimbursable
      Expenses</b>”).</span></h2>

      <h2 class="Heading2"><a name="co_anchor_a1063365_1"></a><span style='font-size:9.0pt;color:#010000'>(h)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
      style='font-size:9.0pt'>Audits.<a name="co_anchor_a1063366_1"></a></span></h2>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(1)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Audit Procedure. Blade Technology
      or its nominee (including its accountants and auditors) may, in Blade
      Technology’s sole discretion, inspect and audit Customer’s use of the Services
      under this Agreement at any time during the Term and for five years following
      the termination or earlier expiration of this Agreement. All audits will be
      conducted during regular business hours.  Customer shall make available all
      such books, records, equipment, information, and personnel, and provide all
      such cooperation and assistance, as may reasonably be requested by or on behalf
      of Blade Technology with respect to such audit.<a name="co_anchor_a1063367_1"></a></span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(2)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Cost and Results of Audit. If the
      audit determines that Customer’s use of the Services exceeded the usage
      permitted by this Agreement, Customer will pay to Blade Technology all amounts
      due for such excess use of the Services, plus interest on such amounts, as
      calculated in accordance with Section 8(d). If the audit determines that such
      excess use equals or exceeds Customer’s permitted level of use, Customer will
      pay to Blade Technology all costs incurred by Blade Technology in conducting
      the audit. Customer shall make all payments required under this Section 8(h)
      within thirty (30) days of the date of written notification of the audit
      results<a name="co_anchor_a606871_1"></a>.</span></h3>

      <h1 class="Heading1"><span style='font-size:9.0pt;color:#010000;font-weight:normal'>9<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Confidentiality.<a
      name="co_anchor_a86897_1"></a></span></h1>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Confidential Information. In
      connection with this Agreement each party (as the “<b>Disclosing Party</b>”)
      may disclose or make available Confidential Information to the other party (as
      the “<b>Receiving Party</b>”). Subject to Section 9(b), “<b>Confidential
      Information</b>” means information in any form or medium (whether oral,
      written, electronic, or other) that the Disclosing Party considers confidential
      or proprietary, including information consisting of or relating to the
      Disclosing Party’s technology, trade secrets, know-how, business operations,
      plans, strategies, customers, and pricing, and information with respect to
      which the Disclosing Party has contractual or other confidentiality obligations,
      in each case whether or not marked, designated, or otherwise identified as
      “confidential”.<a name="co_anchor_a898678_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Exclusions. Confidential
      Information does not include information that the Receiving Party can
      demonstrate by written or other documentary records: (a) was rightfully known
      to the Receiving Party without restriction on use or disclosure prior to such
      information being disclosed or made available to the Receiving Party in
      connection with this Agreement; (b) was or becomes generally known by the
      public other than by the Receiving Party’s or any of its Representatives’
      noncompliance with this Agreement; (c) was or is received by the Receiving
      Party on a non-confidential basis from a third party that was not or is not, at
      the time of such receipt, under any obligation to maintain its confidentiality;
      or (d) was or is independently developed by the Receiving Party without
      reference to or use of any Confidential Information.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Protection of Confidential
      Information. As a condition to being provided with any disclosure of or access
      to Confidential Information, the Receiving Party shall:<a
      name="co_anchor_a97579_1"></a></span></h2>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(1)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>not access or use Confidential
      Information other than as necessary to exercise its rights or perform its
      obligations under and in accordance with this Agreement;<a
      name="co_anchor_a150985_1"></a></span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(2)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>except as may be permitted by and
      subject to its compliance with Section 9(d), not disclose or permit access to
      Confidential Information other than to its Representatives who: (i) need to
      know such Confidential Information for purposes of the Receiving Party’s
      exercise of its rights or performance of its obligations under and in
      accordance with this Agreement; (ii) have been informed of the confidential
      nature of the Confidential Information and the Receiving Party’s obligations
      under this Section 9(c); and (iii) are bound by written confidentiality and
      restricted use obligations at least as protective of the Confidential
      Information as the terms set forth in this Section 9;<a
      name="co_anchor_a990765_1"></a></span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(3)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>safeguard the Confidential
      Information from unauthorized use, access, or disclosure using at least the
      degree of care it uses to protect its most sensitive information and in no
      event less than a reasonable degree of care;</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(4)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>promptly notify the Disclosing
      Party of any unauthorized use or disclosure of Confidential Information and
      take all reasonable steps to prevent further unauthorized use or disclosure;
      and<a name="co_anchor_a1063371_1"></a></span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(5)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>ensure its Representatives’
      compliance with, and be responsible and liable for any of its Representatives’
      non-compliance with, the terms of this Section 9.<a name="co_anchor_a1063372_1"></a></span></h3>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Compelled Disclosures. If the
      Receiving Party or any of its Representatives is compelled by applicable Law to
      disclose any Confidential Information then, to the extent permitted by
      applicable Law, the Receiving Party shall: (a) promptly, and prior to such
      disclosure, notify the Disclosing Party in writing of such requirement so that
      the Disclosing Party can seek a protective order or other remedy or waive its
      rights under Section 9(c); and (b) provide reasonable assistance to the
      Disclosing Party, at the Disclosing Party’s sole cost and expense, in opposing
      such disclosure or seeking a protective order or other limitations on
      disclosure. If the Disclosing Party waives compliance or, after providing the
      notice and assistance required under this Section 9(d), the Receiving Party
      remains required by Law to disclose any Confidential Information, the Receiving
      Party shall disclose only that portion of the Confidential Information that, on
      the advice of the Receiving Party’s legal counsel, the Receiving Party is
      legally required to disclose and, on the Disclosing Party’s request, shall use
      commercially reasonable efforts to obtain assurances from the applicable court
      or other presiding authority that such Confidential Information will be afforded
      confidential treatment.<a name="co_anchor_a883077_1"></a></span></h2>

      <h1 class="Heading1"><span style='font-size:9.0pt;color:#010000;font-weight:normal'>10<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Intellectual Property Rights<a
      name="co_anchor_a332126_1"></a>; Third Party Materials - Vallourec Oil and Gas
      France and Tenaris</span></h1>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Blade Technology Materials. All
      right, title, and interest in and to the Blade Technology Materials, including
      all Intellectual Property Rights therein, are and will remain with Blade
      Technology and, with respect to Third-Party Materials, the applicable
      third-party providers own all right, title, and interest, including all
      Intellectual Property Rights, in and to the Third-Party Materials. Customer has
      no right, license, or authorization with respect to any of the Blade Technology
      Materials except as expressly set forth in Section 2(a) or the applicable
      third-party license, in each case subject to Section 3. All other rights in and
      to the Blade Technology Materials are expressly reserved by Blade Technology.
      In furtherance of the foregoing, Customer hereby unconditionally and
      irrevocably grants to Blade Technology an assignment of all right, title, and
      interest in and to the Resultant Data, including all Intellectual Property
      Rights relating thereto.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Vallourec Oil and Gas France. The
      tubular and connections catalog data contained as part of the Services is not
      exhaustive and includes proprietary and copyrighted data that is owned
      exclusively by Vallourec Oil and Gas France. Vallourec Oil and Gas France
      considers its proprietary and copyrighted catalog data contained inside the Services
      to be a valuable asset. Even if every effort has been made to ensure the
      accuracy and completeness of Vallourec Oil and Gas France’s proprietary and
      copyrighted catalog data contained inside the Services, Vallourec Oil and Gas
      France does not and cannot accept any responsibility for its proprietary and
      copyrighted data contained inside the Services. Customers should therefore
      carry out all necessary investigations to choose for themselves the technical
      solutions suited to the installation and functioning conditions under which
      Vallourec Oil and Gas France’s products will be used. Please check the
      following website <i>www.vamservices.com</i> (and in particular the <u>VAM®
      Book</u>) if you would like the latest or an updated information of Vallourec
      Oil and Gas France’s proprietary and copyrighted catalog data contained inside
      the Services. VAM® is a registered trademark of Vallourec Oil and Gas France.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Tenaris. The tubular and connections
      catalog data contained as part of the Services is not exhaustive and includes
      proprietary and copyrighted data that is owned exclusively by Tenaris and/or
      its affiliated companies (“<b>Tenaris Information</b>”). Tenaris has produced
      Tenaris Information for general information only, and Tenaris Information is
      not intended to constitute professional or any other type of advice or
      recommendation and is provided on an “as is” basis. No warranty is given. The
      use of Tenaris Information is at Customer’s own risk and Tenaris does not
      assume any responsibility or liability of any kind for any loss, damage or
      injury resulting from, or in connection with Tenaris Information or any use
      thereof. Tenaris Information is subject to change or modification without
      notice. Tenaris’s products and services are subject to Tenaris’s standard terms
      and conditions or otherwise to the terms resulting from the respective
      contracts of sale or services, as the case may be. Unless specifically agreed
      under such contract of sale or services, if Tenaris is required to provide any
      warranty or assume any liability in connection with Tenaris Information, any
      such warranty or liability shall be subject to the execution of a separate
      written agreement between Customer and Tenaris. For more complete information
      please contact a Tenaris's representative or visit Tenaris’s website at <i>www.tenaris.com</i>.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Customer Data. As between Customer
      and Blade Technology, Customer is and will remain the sole and exclusive owner
      of all right, title, and interest in and to all Customer Data, including all
      Intellectual Property Rights relating thereto, subject to the rights and
      permissions granted in Section10(c).</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(e)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Consent to Use Customer Data.
      Customer hereby irrevocably grants all such rights and permissions in or relating
      to Customer Data as are necessary or useful to Blade Technology, its
      Subcontractors, and the Blade Technology Personnel to enforce this Agreement
      and exercise Blade Technology’s, its Subcontractors’, and Blade Technology
      Personnel’s rights and perform Blade Technology’s, its Subcontractors’, and Blade
      Technology Personnel’s obligations hereunder.<a name="co_anchor_a846987_1"></a></span></h2>

      <h1 class="Heading1"><span style='font-size:9.0pt;color:#010000;font-weight:normal'>11<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Representations and Warranties.<a
      name="co_anchor_a836306_1"></a></span></h1>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Mutual Representations and
      Warranties. Each party represents and warrants to the other party that:<a
      name="co_anchor_a658769_1"></a></span></h2>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(1)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>it is duly organized, validly
      existing, and in good standing as a corporation or other entity under the Laws
      of the jurisdiction of its incorporation or other organization;<a
      name="co_anchor_a925802_1"></a></span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(2)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>it has the full right, power, and
      authority to enter into and perform its obligations and grant the rights, licenses,
      consents, and authorizations it grants or is required to grant under this
      Agreement;<a name="co_anchor_a124703_1"></a></span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(3)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>the execution of this Agreement by
      its representative whose signature is stated at the end of this Agreement has
      been duly authorized by all necessary corporate or organizational action of
      such party; an<a name="co_anchor_a793581_1"></a>d</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(4)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>when executed and delivered by both
      parties, this Agreement will constitute the legal, valid, and binding
      obligation of such party, enforceable against such party in accordance with its
      terms.</span></h3>

      <h2 class="Heading2"><a name="co_anchor_a543865_1"></a><span style='font-size:9.0pt;color:#010000'>(b)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
      style='font-size:9.0pt'>Additional Blade Technology Representations,
      Warranties, and Covenants. Blade Technology represents, warrants, and covenants
      to Customer that Blade Technology will perform the Services using personnel of
      required skill, experience, and qualifications and in a workmanlike manner in
      accordance with generally recognized industry standards for similar services
      and will devote adequate resources to meet its obligations under this
      Agreement.</span></h2>

      <h2 class="Heading2"><a name="co_anchor_a391736_1"></a><span style='font-size:9.0pt;color:#010000'>(c)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
      style='font-size:9.0pt'>Additional Customer Representations, Warranties, and
      Covenants. Customer represents, warrants, and covenants to Blade Technology
      that Customer owns or otherwise has and will have the necessary rights and
      consents in and relating to the Customer Data so that, as received by Blade
      Technology and Processed in accordance with this Agreement, they do not and
      will not infringe, misappropriate, or otherwise violate any Intellectual
      Property Rights, or any privacy or other rights of any third party or violate
      any applicable Law.</span></h2>

      </div>

      <b><span style='font-size:11.0pt;font-family:"Calibri",sans-serif'><br
      clear=all style='page-break-before:auto'>
      </span></b>

      <div class=Section1>

      <h2 class="Heading2"><span style='font-size:10.0pt;color:#010000;letter-spacing:.6pt'>(d)<span
      style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><b><span
      style='font-size:10.0pt; border:solid 1.0pt'>Disclaimer of Warranties</span></b><span
      style='font-size:10.0pt;letter-spacing:1.0pt'>. <b>EXCEPT FOR THE EXPRESS
      WARRANTIES STATED IN SECTION 11(a) and SECTION 11(b), ALL SERVICES, BLADE
      TECHNOLOGY MATERIALS, and THIRD-PARTY MATERIALS ARE PROVIDED “AS IS.”  </b></span><span
      style='font-size:10.0pt'>Blade Technology specifically disclaims all implied
      warranties of merchantability, fitness for a particular purpose, title, and
      non-infringement, and all warranties arising from course of dealing, usage, or
      trade practice.  Without limiting the foregoing, Blade Technology makes no
      warranty of any kind that the Services or Blade Technology Materials, or any
      results of the use of those Services or Blade Technology Materials, will meet
      Customer’s or any other Persons’ requirements, operate without interruption,
      achieve any intended result, be compatible with or work with any software, systems,
      or other services, or be secure, accurate, complete, free or harmful code, or
      error free. Any representation or warranty of or concerning any representation
      or warranty of or concerning any Third-Party Materials is strictly between
      Customer and Third-Party Materials owner or distributor.<a
      name="co_anchor_a172154_1"></a></span></h2>

      </div>

      <b><span style='font-size:11.0pt;font-family:"Calibri",sans-serif;letter-spacing:
      1.0pt'><br clear=all style='page-break-before:auto'>
      </span></b>

      <div class=Section1>

      <div style='border:solid windowtext 1.0pt;padding:1.0pt 4.0pt 1.0pt 4.0pt'>

      <h1 class="Heading1" style='border:none;padding:0in'><span style='font-size:10.0pt;color:#010000;
      font-weight:normal'>12<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt;letter-spacing:1.0pt'>INDEMNIFICATION
      AND INSURANCE</span><span style='font-size:10.0pt'>.<a
      name="co_anchor_a932438_1"></a></span></h1>

      </div>

      <h2 class="Heading2"><span style='font-size:10.0pt;color:#010000'>(a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><b><span style='font-size:10.0pt; border:solid 1.0pt'>Blade Technology
      Indemnification</span></b><span style='font-size:10.0pt'>. Blade Technology
      shall indemnify, defend, and hold harmless Customer and Customer’s officers,
      directors, employees, agents, permitted successors, and permitted assigns (each,
      a “<b>Customer Indemnitee</b>”) from and against any and all Losses incurred by
      a Customer Indemnitee resulting from any Action by a third party (other than an
      Affiliate of a Customer Indemnitee) that Customer’s or an Authorized User’s use
      of the Services (excluding Customer Data and Third-Party Materials) in
      accordance with this Agreement (including the specifications) infringes or misappropriates
      such third party’s U.S. Intellectual Property Rights. The foregoing obligation
      does not apply to the extent that the alleged infringement arises from:<a
      name="co_anchor_a370373_1"></a></span></h2>

      <h3 class="Heading3"><span style='font-size:10.0pt;color:#010000'>(1)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>Third-Party Materials or Customer
      Data;<a name="co_anchor_a1063373_1"></a></span></h3>

      <h3 class="Heading3"><span style='font-size:10.0pt;color:#010000'>(2)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>access to or use of the Blade
      Technology Materials in combination with any hardware, system, software,
      network, or other materials or service not provided by Blade Technology or
      specified for Customer’s use in the Documentation;<a name="co_anchor_a56570_1"></a></span></h3>

      <h3 class="Heading3"><span style='font-size:10.0pt;color:#010000'>(3)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>modification of the Blade
      Technology Materials other than: (i) by or on behalf of Blade Technology; or
      (ii) with Blade Technology’s written approval in accordance with Blade
      Technology’s written specification;<a name="co_anchor_a263560_1"></a></span></h3>

      <h3 class="Heading3"><span style='font-size:10.0pt;color:#010000'>(4)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>failure to timely implement any
      modifications, upgrades, replacements, or enhancements made available to
      Customer by or on behalf of Blade Technology; or<a name="co_anchor_a377009_1"></a></span></h3>

      <h3 class="Heading3"><span style='font-size:10.0pt;color:#010000'>(5)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>act, omission, or other matter
      described in Section 12(b)(1) and Section 12(b)(2), whether or not the same
      results in any Action against or Losses by any Blade Technology Indemnitee.<a
      name="co_anchor_a934712_1"></a></span></h3>

      <h2 class="Heading2"><span style='font-size:10.0pt;color:#010000'>(b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><b><span style='font-size:10.0pt; border:solid 1.0pt'>Customer Indemnification</span></b><span
      style='font-size:10.0pt'>.</span></h2>

      <h3 class="Heading3"><a name="_Hlk529790711"><span style='font-size:10.0pt;color:#010000'>(1)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>Customer shall release, indemnify,
      defend, and hold harmless Blade Technology and its Subcontractors, Affiliates,
      provider of Third-Party Materials, and each of its and their respective
      officers, directors, members, managers, employees, contractors, consultants,
      agents, successors, and assigns, all of any tier (each, a “<b>Blade Technology
      Indemnitee</b>”) from and against any and all Losses incurred by any one or
      more Blade Technology Indemnitees resulting from any Action by any Person <b><span
      style='letter-spacing:1.0pt'>REGARDLESS OF THE CAUSE OR CAUSES THEREOF,
      INCLUDING THE SOLE, JOINT, OR CONCURRENT NEGLIGENCE (IN ANY AMOUNT), GROSS
      NEGLIGENCE OR WILLFUL MISCONDUCT, STRICT LIABILITY, BREACH OF WARRANTY, BREACH
      OF DUTY (STATUTORY OR OTHERWISE), BREACH OF CONTRACT, OR ANY OTHER LEGAL FAULT,
      LIABILITY, OR RESPONSIBILITY OF ANY ONE OR MORE BLADE TECHNOLOGY INDEMNITEES </span></b></span></a><span
      style='font-size:10.0pt'>that arise out of or result from, or are alleged to
      arise out of or result from any one or more or the following:</span></h3>

      <h4 class="Heading4"><span style='font-size:10.0pt;color:#010000'>(A)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>bodily injury or death suffered by
      Customer, Customer’s Affiliates, and Customer’s clients (including any of its
      or their co-working, non-working, operating and any other interest owners),
      lessors, co-lessees and each of their respective officers, directors,
      employees, contractors, consultants, vendors, agents, representatives, invitees,
      licensees, successors or assigns; all of any tier;</span></h4>

      <h4 class="Heading4"><span style='font-size:10.0pt;color:#010000'>(B)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>damage to or loss of property
      suffered by Customer, Customer’s Affiliates, and Customer’s clients (including
      any of its or their co-working, non-working, operating and any other interest
      owners), lessors, co-lessees and each of their respective officers, directors,
      employees, contractors, consultants, vendors, agents, representatives,
      invitees, licensees, successors or assigns, all of any tier;</span></h4>

      <h4 class="Heading4"><span style='font-size:10.0pt;color:#010000'>(C)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>pollution, contamination, or any
      kind of catastrophic loss, or other loss related to or arising from, or
      connected in any way to the Services, Customer, or any other reason or cause.</span></h4>

      <h3 class="Heading3"><span style='font-size:10.0pt;color:#010000'>(2)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>Subject to Section 12(b)(1),
      Customer shall release, indemnify, defend, and hold harmless all Blade
      Technology Indemnitees from and against any and all Losses incurred by any one
      or more Blade Technology Indemnitees resulting from any Action by a third party
      (other than an Affiliate of a Blade Technology Indemnitee) that arise out of or
      result from, or are alleged to arise out of or result from:<a
      name="co_anchor_a347239_1"></a></span></h3>

      <h4 class="Heading4"><span style='font-size:10.0pt;color:#010000'>(A)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>Customer Data, including any
      Processing of Customer Data by or on behalf of Blade Technology in accordance
      with this Agreement;<a name="co_anchor_a375238_1"></a></span></h4>

      <h4 class="Heading4"><span style='font-size:10.0pt;color:#010000'>(B)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>any other materials or information
      (including any documents, data, specifications, software, content, or
      technology) provided by or on behalf of Customer or any Authorized User,
      including Blade Technology’s compliance with any specifications or directions
      provided by or on behalf of Customer or any Authorized User to the extent
      prepared without any contribution by Blade Technology;</span></h4>

      <h4 class="Heading4"><span style='font-size:10.0pt;color:#010000'>(C)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>allegation of facts that, if true,
      would constitute Customer’s breach of any of its representations, warranties,
      covenants, or obligations under this Agreement; </span></h4>

      <h4 class="Heading4"><span style='font-size:10.0pt;color:#010000'>(D)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>Customer’s violation or breach of
      any term or condition of this Agreement or any applicable law, regulation,
      policy, or guideline, whether or not referenced herein;</span></h4>

      <h4 class="Heading4"><span style='font-size:10.0pt;color:#010000'>(E)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>negligence or more culpable act or
      omission (including gross negligence, recklessness, or willful misconduct) by
      Customer, any Authorized User, or any third party on behalf of Customer or any
      Authorized User, in connection with this Agreement<a name="co_anchor_a514095_1"></a>.</span></h4>

      <h2 class="Heading2"><span style='font-size:10.0pt;color:#010000'>(c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><b><span style='font-size:10.0pt; border:solid 1.0pt'>Indemnification Procedure</span></b><span
      style='font-size:10.0pt'>. Each party shall promptly notify the other party in
      writing of any Action for which such party believes it is entitled to be
      indemnified under this Section 12, as the case may be. The party seeking
      indemnification (the “<b>Indemnitee</b>”) shall cooperate with the other party
      (the “<b>Indemnitor</b>”) at the Indemnitor’s sole cost and expense. The
      Indemnitor shall promptly assume control of the defense and shall employ
      counsel reasonably acceptable to the Indemnitee to handle and defend the same,
      at the Indemnitor’s sole cost and expense. The Indemnitee may participate in
      and observe the proceedings at its own cost and expense with counsel of its own
      choosing. The Indemnitor shall not settle any Action without the Indemnitee’s
      prior written consent, which shall not be unreasonably withheld or delayed. If
      the Indemnitor fails or refuses to assume control of the defense of such
      Action, the Indemnitee shall have the right, but no obligation, to defend
      against such Action, including settling such Action after giving notice to the
      Indemnitor, in each case in such manner and on such terms as the Indemnitee may
      deem appropriate. The Indemnitee’s failure to perform any obligations under
      this Section 12(c) will not relieve the Indemnitor of its obligations under
      this Section 12, except to the extent that the Indemnitor can demonstrate that
      it has been prejudiced as a result of such failure.</span></h2>

      <h2 class="Heading2"><a name="co_anchor_a631590_1"></a><span style='font-size:10.0pt;color:#010000'>(d)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><b><span
      style='font-size:10.0pt; border:solid 1.0pt'>Mitigation</span></b><span style='font-size:10.0pt'>.
      If any of the Services or Blade Technology Materials are, or in Blade
      Technology’s opinion are likely to be, claimed to infringe, misappropriate, or
      otherwise violate any third-party Intellectual Property Right, or if Customer’s
      or any Authorized User’s use of the Services or Blade Technology Materials is
      enjoined or threatened to be enjoined, Blade Technology may, at its option and
      sole cost and expense:</span></h2>

      <h3 class="Heading3"><span style='font-size:10.0pt;color:#010000'>(1)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>obtain the right for Customer to
      continue to use the Services and Blade Technology Materials as contemplated by
      this Agreement;</span></h3>

      <h3 class="Heading3"><span style='font-size:10.0pt;color:#010000'>(2)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>modify or replace the Services and
      Blade Technology Materials, in whole or in part, to seek to make the Services
      and Blade Technology Materials (as so modified or replaced) non-infringing,
      while providing equivalent features and functionality, in which case such
      modifications or replacements will constitute Services and Blade Technology
      Materials, as applicable, under this Agreement; or</span></h3>

      <h3 class="Heading3"><span style='font-size:10.0pt;color:#010000'>(3)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>by written notice to Customer,
      terminate this Agreement with respect to all or part of the Services and Blade
      Technology Materials, and require Customer to immediately cease any use of the
      Services and Blade Technology Materials or any specified part or feature
      thereof.</span></h3>

      <h2 class="Heading2"><span style='font-size:10.0pt;color:#010000'>(e)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><b><span style='font-size:10.0pt; border:solid 1.0pt'>Sole Remedies for Infringement</span></b><span
      style='font-size:10.0pt'>. This Section 12 states Customer’s sole remedies and
      Blade Technology Indemnitees’ sole liability and obligation for any actual,
      threatened, or alleged Actions that the Services and Blade Technology Materials
      or any subject matter under this Agreement infringes, misappropriates, or
      otherwise violates any intellectual property rights or any third party.</span></h2>

      <h2 class="Heading2"><a name="_Hlk17011248"><span style='color:#010000'>(f)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><b><span
      style='font-size:10.0pt; border:solid 1.0pt'>Insurance</span>.</b></a><span style='font-size:10.0pt'>
      In support of the indemnity obligations contained in this Section 12, Customer
      agrees to maintain at its own expense policies of insurance with (a) insurers
      that maintain an AM Best rating of B+ or higher and (b) with the necessary
      insurance coverage to cover those indemnity obligations.  Customer shall
      maintain all insurances required by applicable law.  Customer shall keep all
      insurance policies in full force and effect stated above for the full period of
      this Agreement, at Customer’s sole cost and expense and require the
      underwriters to waive their rights of subrogation against all Blade Technology
      Indemnitees with the exception that professional liability (E&amp;O)
      underwriters are not required to waive their rights of subrogation. Customer waives
      its rights of subrogation against Blade Technology Indemnitees and Blade
      Technology Indemnitees’ insurers for the risks, liabilities, and indemnity
      obligations agreed to by Customer under this Agreement.  Except for worker's
      compensation, employer’s liability and professional liability insurance, all
      policies shall name all Blade Technology Indemnitees as additional insureds,
      and all such insurance policies shall be specified as primary and
      noncontributory regardless of any other insurance carried by any one or more
      Blade Technology Indemnitees.  The insurance policies obtained by Customer to
      cover its indemnity obligations under this Section 12 are not to limit each Customer’s
      indemnity obligations except to the extent provided by applicable law.</span></h2>

      <p class=BodyText>&nbsp;</p>

      </div>

      <b><span style='font-size:11.0pt;font-family:"Calibri",sans-serif'><br
      clear=all style='page-break-before:auto'>
      </span></b>

      <div class=Section1>

      <div style='border:solid windowtext 1.0pt;padding:1.0pt 4.0pt 1.0pt 4.0pt'>

      <h1 class="Heading1" style='border:none;padding:0in'><span style='font-size:10.0pt;color:#010000;
      font-weight:normal'>13<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt;letter-spacing:1.0pt'>HIGH-RISK
      ACTIVITIES AND LIMITATIONS OF LIABILITY</span><span style='font-size:10.0pt'>.<a
      name="co_anchor_a367960_1"></a></span></h1>

      </div>

      <h2 class="Heading2"><span style='font-size:10.0pt;color:#010000'>(a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><b><span style='font-size:10.0pt; border:solid 1.0pt'>High-Risk Activities</span></b><span
      style='font-size:10.0pt'>. Customer acknowledges that the Services are highly
      specialized, represent the contributions of multiple providers, and cannot be
      and are not represented or warranted to be fail-safe, fault tolerant or free
      from errors, bugs, conflicts, interrupts, or similar limitations.  Customer’s
      acceptance of this Agreement and the conditions and limitations herein provided
      and use of the Services constitutes Customer’s acknowledgment and agreement
      that the disclaimers of warranties and limitations of remedies as provided in
      this Agreement are reasonable and accepted by Customer and are supported by
      adequate and sufficient consideration.  Customer acknowledges that it is solely
      responsible for determining that the Services are suitable in quality,
      application and performance for Customer’s use.  Customer expressly assumes the
      risk of all loss, or damage or other liability pertaining to activities in
      which any combination of: (1) the Services, (2) any error, deviation or
      interruption in the Services, or (3) any error, deviation or interruption
      caused by the Services could lead to any (material or otherwise) injury of
      individuals, entities, governments, business, persons, property, or the
      environment.  Customer further acknowledges Blade Technology would not be
      willing to provide the Services without Customer’s acknowledgment of its
      assumption of all risks as stated in the previous sentence and Customer’s
      acceptance of the terms and conditions of this Section.  <b><span
      style='letter-spacing:1.0pt'>TO THE EXTENT ALLOWED BY LAW AND EXCEPT AS
      OTHERWISE PROVIED IN THIS AGREEMENT, CUSTOMER ON BEHALF OF ITSELF AND ALL
      CUSTOMER INDEMNITEES HEREBY WAIVES ANY ACTIONS IT MAY NOW OR HEREAFTER HAVE AS
      A RESULT OF USE OF THE SERVICES, TO THE EXTENT SUCH ACTIONS WOULD BE BROUGHT
      AGAINST ANY ONE OR MORE BLADE TECHNOLOGY INDEMNITEES</span></b>.</span></h2>

      <h2 class="Heading2"><span style='font-size:10.0pt;color:#010000'>(b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><b><span style='font-size:10.0pt; border:solid 1.0pt'>Full Understanding</span></b><span
      style='font-size:10.0pt'>. Customer represents that it is sophisticated and has
      consulted its own technical and software engineers and legal counsel with the
      special knowledge, training, and experience to judge the software and this
      Agreement.   If Customer has not consulted technical and software engineers and
      legal counsel with the special knowledge, training and experience to judge the
      software, Customer acknowledges that it was provided the opportunity and had
      the ability to so consult and made an informed decision not to so consult, and
      Customer fully understands the limits and capabilities of the Services and
      obligations by accepting this Agreement.</span></h2>

      <h2 class="Heading2"><span style='font-size:10.0pt;color:#010000'>(c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><b><span style='font-size:10.0pt; border:solid 1.0pt'>Exclusion of Damages</span></b><span
      style='font-size:10.0pt;letter-spacing:1.0pt'>. </span><span style='font-size:
      10.0pt'>In no event will any one or more Blade Technology Indemnitees be liable
      under or in connection with this Agreement or its subject matter under any
      legal or equitable theory, including breach of contract, tort (including
      negligence), strict liability, or otherwise, for any: (1) loss of production,
      use, business, revenue, or profit, or diminution in value; (2) impairment,
      inability to use or loss, interruption or delay of the Services, losses from
      inability to use of loss of rigs, vessels, or facilities; (3) loss, damage,
      corruption, or recovery of data, or breach of data or system security; (4) cost
      of replacing goods or services; (5) loss of goodwill or reputation; or (6)
      consequential, incidental, indirect, exemplary, special, enhanced, or punitive
      damages, <b><span style='letter-spacing:1.0pt'>REGARDLESS OF WHETHER SUCH
      PERSONS WERE ADVISED OF THE POSSIBILITY OF SUCH LOSSES OR SUCH LOSSES WERE
      OTHERWISE FORESEEABLE, AND NOTWITHSTANDING THE FAILURE OF ANY AGREED OR OTHER
      REMEDY OF ITS ESSENTIAL PURPOSE</span></b>.</span></h2>

      <h2 class="Heading2"><a name="co_anchor_a154333_1"></a><span style='font-size:10.0pt;color:#010000;
      letter-spacing:1.0pt'>(d)<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span><b><span
      style='font-size:10.0pt; border:solid 1.0pt'>Liability Cap, Release, and Indemnification</span></b><span
      style='font-size:10.0pt;letter-spacing:1.0pt'>. </span><span style='font-size:
      10.0pt'>In no event will the collective aggregate liability of any one or more
      Blade Technology Indemnitees arising out of or related to this Agreement<span
      style='letter-spacing:1.0pt'>, </span>whether arising under or related to
      breach of contract, tort (including negligence), strict liability, or any other
      legal or equitable theory, <a name="_Hlk528767203">exceed the total amounts
      paid to Blade Technology under this Agreement in the six-month period preceding
      the event giving rise to the Action<span style='letter-spacing:1.0pt'>, </span></a><b><span
      style='letter-spacing:1.0pt'>REGARDLESS OF THE CAUSE OR CAUSES THEREOF,
      INCLUDING THE SOLE, JOINT, OR CONCURRENT NEGLIGENCE (IN ANY AMOUNT), GROSS
      NEGLIGENCE OR WILLFUL MISCONDUCT, STRICT LIABILITY, BREACH OF WARRANTY, BREACH
      OF DUTY (STATUTORY OR OTHERWISE), BREACH OF CONTRACT, OR ANY OTHER LEGAL FAULT,
      LIABILITY, OR RESPONSIBILITY OF ANY ONE OR MORE BLADE TECHNOLOGY INDEMNITEES</span></b><span
      style='letter-spacing:1.0pt'>.  <b>THE FOREGOING LIMITATIONS APPLY EVEN IF ANY
      REMEDY FAILS OF ITS ESSENTIAL PURPOSE</b>.</span>  Customer shall release,
      indemnify, defend, and hold harmless all Blade Technology Indemnitees from and
      against any and all Losses incurred by such Blade Technology Indemnitees
      resulting from any Action by any Person <b><span style='letter-spacing:1.0pt'>REGARDLESS
      OF THE CAUSE OR CAUSES THEREOF, INCLUDING THE SOLE, JOINT, OR CONCURRENT
      NEGLIGENCE (IN ANY AMOUNT), GROSS NEGLIGENCE OR WILLFUL MISCONDUCT, STRICT
      LIABILITY, BREACH OF WARRANTY, BREACH OF DUTY (STATUTORY OR OTHERWISE), BREACH
      OF CONTRACT, OR ANY OTHER LEGAL FAULT, LIABILITY, OR RESPONSIBILITY OF ANY ONE
      OR MORE BLADE TECHNOLOGY INDEMNITEES</span></b><span style='letter-spacing:
      1.0pt'> </span>that exceed the total amounts paid to Blade Technology under
      this Agreement in the six-month period preceding the event giving right to the
      Action.  Except as otherwise provided by law, Customer acknowledges that
      Customer’s right to recover damages within the limitations specified in this
      Agreement is Customer’s exclusive remedy in the event any other contractual
      remedy fails in its essential purpose, and that these limitations apply as a
      maximum cumulative amount limited to all Actions globally as may be made by or
      on behalf of the Customer or any Authorized User. <span style='letter-spacing:
      1.0pt'> <b>CUSTOMER AND ALL AUTHORIZED USERS USING THE SERVICES ACKNOWLEDGE
      THAT THE PROVISIONS AND LIMITATIONS STATED IN THIS SECTION ARE REASONABLE
      GIVEN, AMONG OTHER FACTORS, THE FEES PAID OR PAYABLE UNDER THIS AGREEMENT AND
      EACH OF THE PARTIES’ KNOWLEDGE (INCLUDING DEEMED KNOWLEDGE) OF THE EXISTENCE OF
      THE PROVISIONS OF THIS SECTION.</b></span></span></h2>

      </div>

      <b><span style='font-size:11.0pt;font-family:"Calibri",sans-serif'><br
      clear=all style='page-break-before:auto'>
      </span></b>

      <div class=Section3>

      <h1 class="Heading1"><a name="co_anchor_a804571_1"></a><span style='font-size:9.0pt;color:#010000;
      font-weight:normal'>14<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Term, Termination and Renewal.</span></h1>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Initial Term. The initial term of
      this Agreement commences as of the Effective Date and, unless terminated
      earlier pursuant any of the Agreement’s express provisions, will continue in
      effect as agreed to the parties in writing before use of the Services (the “</span><b><span
      style='font-size:9.0pt'>Initial</span></b><span style='font-size:9.0pt'> <b>Term</b>”).<a
      name="co_anchor_a778854_1"></a></span></h2>

      <h2 class="Heading2"><a name="co_anchor_a555413_1"></a><span style='font-size:9.0pt;color:#010000'>(b)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
      style='font-size:9.0pt'>Renewal Term. This Agreement will automatically renew
      for additional successive terms that are equal in length to the Initial Term
      until earlier terminated in accordance with this Agreement’s express provisions
      or either party gives the other party Notice of non-renewal at least thirty
      (30) days prior to the expiration of the then-current term (each a “Renewal
      Term” and together with the Initial Term, the “Term”).  Subject to any change
      of this Agreement’s terms provided in writing by courier, electronic mail, or
      otherwise to Customer at least thirty (30) days before the start of the
      applicable Renewal Term including, without limitation, any change in the Fees
      payable hereunder by Customer, the terms of this Agreement during each such
      Renewal Term will be the same as the terms in effect between the parties
      immediately before such renewal.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(c)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Termination. In addition to any
      other express termination right stated elsewhere in this Agreement:</span></h2>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(1)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Blade Technology may terminate this
      Agreement, effective on written notice to Customer, if Customer:</span></h3>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(A)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>fails to pay any amount when due
      hereunder, and such failure continues more than seven (7) days after Blade
      Technology’s delivery of written notice thereof; or </span></h4>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(B)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>breaches any of its obligations
      under Section 3, Section 7(c), or Section 9;</span></h4>

      <h3 class="Heading3"><a name="co_anchor_a399239_1"></a><span style='font-size:9.0pt;color:#010000'>(2)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Blade Technology may terminate this
      Agreement, effective on written notice to the Customer, if the Customer breaches
      this Agreement, and such breach:</span></h3>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(A)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>is incapable of cure; or</span></h4>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(B)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>being capable of cure, remains
      uncured seven (7) days after the non-breaching party provides the breaching
      party with written notice of such breach; and</span></h4>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(3)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>either party may terminate this
      Agreement, effective immediately upon written notice to the other party, if the
      other party:</span></h3>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(A)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>becomes insolvent or is generally
      unable to pay, or fails to pay, its debts as they become due;</span></h4>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(B)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>files or has filed against it, a
      petition for voluntary or involuntary bankruptcy, winding up, or otherwise
      becomes subject, voluntarily or involuntarily, to any proceeding under any
      domestic or foreign bankruptcy or insolvency Law;</span></h4>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(C)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>makes or seeks to make a general
      assignment for the benefit of its creditors; or</span></h4>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(D)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>applies for or has appointed a
      receiver, trustee, custodian, or similar agent appointed by order of any court
      of competent jurisdiction to take charge of or sell any material portion of its
      property or business.</span></h4>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(4)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>if the Initial Term or Renewal Term
      agreed upon is less than one year, Customer has no right to terminate this
      Agreement during the then-current term.  If the Initial Term or Renewal Term is
      greater than one year, Customer may terminate this Agreement after six months
      of the then-current term, effective immediately by providing written notice to
      Blade Technology.</span></h3>

      <h2 class="Heading2"><a name="co_anchor_a333380_1"></a><span style='font-size:9.0pt;color:#010000'>(d)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
      style='font-size:9.0pt'>Effect of Termination or Expiration. Upon any
      expiration or termination of this Agreement, except as expressly otherwise
      provided in this Agreement:<a name="co_anchor_a763223_1"></a></span></h2>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(1)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>all rights, licenses, consents, and
      authorizations granted by either party to the other hereunder will immediately
      terminate;</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(2)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Blade Technology shall promptly
      cease all use of any Customer Data or Customer’s Confidential Information and</span></h3>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(A)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>promptly return to Customer, or at
      Customer’s written request destroy, all documents and tangible materials
      containing, reflecting, incorporating, or based on Customer Data or Customer’s
      Confidential Information; and</span></h4>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(B)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>permanently erase all Customer Data
      and Customer’s Confidential Information from all systems Blade Technology directly
      or indirectly controls, provided that, for clarity, Blade Technology’s
      obligations under this Section 14(d)(2) do not apply to any Resultant Data;</span></h4>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(3)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Customer shall immediately cease
      all use of any Services or Blade Technology Materials and </span></h3>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(A)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>promptly return to Blade Technology,
      or at Blade Technology’s written request destroy, all documents and tangible
      materials containing, reflecting, incorporating, or based on any Blade
      Technology Materials or Blade Technology’s Confidential Information; </span></h4>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(B)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>permanently erase all Blade
      Technology Materials and Blade Technology’s Confidential Information from all
      systems Customer directly or indirectly controls; and </span></h4>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(C)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>certify to Blade Technology in a
      signed written instrument that it has complied with the requirements of this Section
      14(d)(3);</span></h4>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(4)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>notwithstanding anything to the
      contrary in this Agreement, with respect to information and materials then in
      its possession or control Blade Technology may retain Customer Data in its
      backups, archives, and disaster recovery systems until such Customer Data is
      deleted in the ordinary course<a name="co_anchor_a471871_1"></a>.</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(5)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Blade Technology may disable all
      Customer and Authorized User access to the Blade Technology Materials;</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(6)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>If Blade Technology terminates this
      Agreement pursuant to Section 14(c)(1) or Section 14(c)(2), all Fees that would
      have become payable had the Agreement remained in effect until expiration of
      the Term will immediately become and remain due and payable, and Customer shall
      pay such Fees, together with all previously-accrued but not yet paid Fees and
      Reimbursable Expenses, on receipt of Blade Technology’s invoice therefor.</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(7)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>If Customer terminates this
      Agreement in accordance with Section 14(c)(4), then:</span></h3>

      <h3 class="Heading3" style='margin-left:.5in;text-indent:0in'><span style='font-size:9.0pt'>(A)           for
      any Initial Term or Renewal Term less than one year, no refund will be provided
      to Customer; and</span></h3>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(B)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>for any Initial Term or Renewal
      Term greater than one year, a refund in proportion to the unused portion of the
      then-current term will be provided to the Customer.</span></h4>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(e)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Surviving Terms. The provisions stated
      in the following sections, and any other right or obligation of the parties in
      this Agreement that, by its nature, should survive termination or expiration of
      this Agreement, will survive any expiration or termination of this Agreement: Section
      3, Section 9, Section 11(d), Section 12, Section 13, Section 14(d), this Section
      14(e), and Section 15.<a name="co_anchor_a766208_1"></a></span></h2>

      <h1 class="Heading1"><span style='font-size:9.0pt;color:#010000;font-weight:normal'>15<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Miscellaneous.</span></h1>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(a)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Further Assurances. On a party’s
      reasonable request, the other party shall, at the requesting party’s sole cost
      and expense, execute and deliver all such documents and instruments, and take
      all such further actions, as may be necessary to give full effect to this
      Agreement.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(b)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Relationship of the Parties. The
      relationship between the parties is that of independent contractors. Nothing
      contained in this Agreement shall be construed as creating any agency,
      partnership, joint venture, or other form of joint enterprise, employment, or
      fiduciary relationship between the parties, and neither party shall have
      authority to contract for or bind the other party in any manner whatsoever.</span></h2>

      <h2 class="Heading2"><a name="co_anchor_a287713_1"></a><span style='font-size:9.0pt;color:#010000'>(c)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span><span
      style='font-size:9.0pt'>Public Announcements. Neither party shall issue or
      release any announcement, statement, press release, or other publicity or
      marketing materials relating to this Agreement or, unless expressly permitted
      under this Agreement, otherwise use the other party’s trademarks, service
      marks, trade names, logos, domain names, or other indicia of source,
      association, or sponsorship, in each case, without the prior written consent of
      the other party, which consent shall not be unreasonably withheld, with the
      sole exceptions being that Blade Technology may, without Customer’s consent,
      include Customer’s name, logo, website link, and other indicia in its lists of Blade
      Technology’s current or former customers of Blade Technology in promotional and
      marketing materials on any form of media.<a name="co_anchor_a949452_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(d)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Notices. Each party shall deliver
      all notices, requests, consents, claims, demands, waivers, and other
      communications under this Agreement (each, a “<b>Notice</b>”) in writing and
      addressed to the other party at the addresses set forth in the preamble of this
      Agreement, the address Customer provides to Blade Technology before use of the
      Services, or to such other address that the receiving party may designate from
      time to time in accordance with this Section. Each party shall deliver all
      Notices by personal delivery, internationally recognized overnight courier
      (with all fees prepaid), facsimile (with confirmation of transmission), or
      certified or registered mail (in each case, return receipt requested, postage
      prepaid).  Except as otherwise provided in this Agreement, a Notice is
      effective only (a) upon receipt by the receiving party and (b) if the party
      giving the Notice has complied with the requirements of this Section.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(e)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Interpretation. For purposes of
      this Agreement:</span></h2>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(1)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>the words “include,” “includes,”
      and “including” are deemed to be followed by the words “without limitation”; </span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(2)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>the word “or” is not exclusive; </span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(3)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>the words “herein,” “hereof,”
      “hereby,” “hereto,” and “hereunder” refer to this Agreement as a whole; </span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(4)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>words denoting the singular have a
      comparable meaning when used in the plural, and vice-versa; </span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(5)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>words <a name="_Hlk529796692">denoting
      </a>the defined terms stated in this Agreement have the same meaning even if
      otherwise stated in all capital letters; and</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(6)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>words denoting any gender include
      all genders.</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(7)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Unless the context otherwise
      requires, references in this Agreement:</span></h3>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(A)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>to sections, exhibits, schedules,
      attachments, and appendices mean the sections of, and exhibits, schedules,
      attachments, and appendices attached to, this Agreement;</span></h4>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(B)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>to an agreement, instrument, or
      other document means such agreement, instrument, or other document as amended,
      supplemented, and modified from time to time to the extent permitted by the
      provisions thereof; and</span></h4>

      <h4 class="Heading4"><span style='font-size:9.0pt;color:#010000'>(C)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>to a statute means such statute as
      amended from time to time and includes any successor legislation thereto and
      any regulations promulgated thereunder.</span></h4>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(8)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>The parties intend this Agreement
      to be construed without regard to any presumption or rule requiring
      construction or interpretation against the party drafting an instrument or
      causing any instrument to be drafted. The exhibits, schedules, attachments, and
      appendices referred to herein are an integral part of this Agreement to the
      same extent as if they were set forth verbatim herein.<a
      name="co_anchor_a169716_1"></a></span></h3>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(f)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Headings. The headings in this
      Agreement are for reference only and do not affect the interpretation of this
      Agreement.<a name="co_anchor_a1052220_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(g)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Entire Agreement. This Agreement,
      together with any other documents incorporated herein by reference, constitutes
      the sole and entire agreement of the parties with respect to the subject matter
      of this Agreement and supersedes all prior and contemporaneous understandings,
      agreements, representations, and warranties, both written and oral, with respect
      to such subject matter. In the event of any inconsistency between the
      statements made in the body of this Agreement, the related exhibits, schedules,
      attachments, and appendices and any other documents incorporated herein by
      reference, the following order of precedence governs: (a) first, this
      Agreement, excluding its exhibits, schedules, attachments, and appendices; (b)
      second, the exhibits, schedules, attachments, and appendices to this Agreement
      as of the Effective Date; and (c) third, any other documents incorporated
      herein by reference.<a name="co_anchor_a682162_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(h)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Assignment. Customer shall not
      assign or otherwise transfer any of its rights, or delegate or otherwise
      transfer any of its obligations or performance under this Agreement, in each
      case whether voluntarily, involuntarily, by operation of law, or otherwise,
      without Blade Technology’s prior written consent. For purposes of the preceding
      sentence, and without limiting its generality, any merger, consolidation, or
      reorganization involving Customer (regardless of whether Customer is a
      surviving or disappearing entity) will be deemed to be a transfer of rights, obligations,
      or performance under this Agreement for which Blade Technology’s prior written
      consent is required. No assignment, delegation, or transfer will relieve
      Customer of any of its obligations or performance under this Agreement. Any
      purported assignment, delegation, or transfer in violation of this Section
      15(h) is void. This Agreement is binding upon and inures to the benefit of the
      parties hereto and their respective successors and permitted assigns.<a
      name="co_anchor_a372770_1"></a></span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(i)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Force Majeure.<a
      name="co_anchor_a1020163_1"></a></span></h2>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(1)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>No Breach or Default. In no event
      will Blade Technology be liable or responsible to Customer, or be deemed to
      have defaulted under or breached this Agreement, for any failure or delay in
      fulfilling or performing any term of this Agreement, when and to the extent
      such failure or delay is caused by any circumstances beyond Blade Technology’s
      reasonable control (a “<b>Force Majeure Event</b>”), including acts of God,
      flood, fire, earthquake or explosion, war, terrorism, invasion, riot or other
      civil unrest, embargoes or blockades in effect on or after the date of this
      Agreement, national or regional emergency, strikes, labor stoppages or
      slowdowns or other industrial disturbances, passage of Law or any action taken
      by a governmental or public authority, including imposing an embargo, export or
      import restriction, quota, or other restriction or prohibition or any complete
      or partial government shutdown, or national or regional shortage of adequate
      power or telecommunications or transportation. Either party may terminate this
      Agreement if a Force Majeure Event affecting the other party continues
      substantially uninterrupted for a period of thirty (30) days or more.</span></h3>

      <h3 class="Heading3"><span style='font-size:9.0pt;color:#010000'>(2)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Affected Party Obligations. In the
      event of any failure or delay caused by a Force Majeure Event, Blade Technology
      shall give prompt written notice to Customer stating the period of time the
      occurrence is expected to continue and use commercially reasonable efforts to
      end the failure or delay and minimize the effects of such Force Majeure Event.</span></h3>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(j)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Third-Party Beneficiaries. This
      Agreement confers right and remedies upon the Vallourec Oil and Gas France as
      stated in Section 10(b), Tenaris and/or its Affiliates as stated in Section
      10(c), and Blade Technology Indemnitees as stated throughout the Agreement, and
      not any individual, person, or entity other than any combination of the
      parties, Vallourec Oil and Gas France, Tenaris and/or its Affiliates, or other Blade
      Technology Indemnitees have any rights or remedies under the Agreement. The
      parties reserve the power to modify or terminate this Agreement without the
      consent of the Vallourec Oil and Gas France, Tenaris and/or its Affiliates, or
      other Blade Technology Indemnitees.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(k)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Amendment and Modification; Waiver.
      Subject to Section 14(b), no amendment to or modification of or rescission, termination,
      or discharge of this Agreement is effective unless it is in writing, identified
      as an amendment to or rescission, termination, or discharge of this Agreement
      and signed by an authorized representative of each party. No waiver by any
      party of any of the provisions hereof shall be effective unless explicitly set
      forth in writing and signed by the party so waiving. Except as otherwise set
      forth in this Agreement, no failure to exercise, or delay in exercising, any
      rights, remedy, power, or privilege arising from this Agreement will operate or
      be construed as a waiver thereof; nor shall any single or partial exercise of
      any right, remedy, power, or privilege hereunder preclude any other or further
      exercise thereof or the exercise of any other right, remedy, power, or
      privilege.</span></h2>

      <h2 class="Heading2"><span style='font-size:9.0pt;color:#010000'>(l)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:9.0pt'>Severability. If any term or
      provision of this Agreement is invalid, illegal, or unenforceable in any
      jurisdiction, such invalidity, illegality, or unenforceability shall not affect
      any other term or provision of this Agreement or invalidate or render
      unenforceable such term or provision in any other jurisdiction.</span></h2>

      </div>

      <span style='font-size:11.0pt;font-family:"Calibri",sans-serif'><br clear=all
      style='page-break-before:auto'>
      </span>

      <div class=Section1>

      <h2 class="Heading2" style='margin-left:.25in'><span style='font-size:10.0pt;color:#010000'>(m)<span
      style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp; </span></span><b><span
      style='font-size:10.0pt; border:solid 1.0pt'>Governing Law; Dispute Resolution</span></b><span
      style='font-size:10.0pt'>. This Agreement is governed by and construed in
      accordance with the substantive laws of the State of Texas, United States
      without giving effect to any choice or conflict of law provision or rule that
      would require or permit the application of the laws of any jurisdiction other
      than those of the State of Texas, United States.</span></h2>

      <h2 class="Heading2" style='margin-left:.25in;text-indent:0in'><span style='font-size:10.0pt'>(1)                   United
      States Domestic Disputes: Any legal suit, action, or proceeding arising out of
      or relating to this Agreement or the transactions contemplated hereby between
      Persons of United States nationalities shall be instituted in the federal
      courts of the United States of America or the courts of the State of Texas in
      each case located in the City of Houston and Harris County, and those parties
      irrevocably submit to the exclusive jurisdiction of such courts in any such
      suit, action, or proceeding.</span></h2>

      <h2 class="Heading2" style='margin-left:.25in;text-indent:0in'><span style='font-size:10.0pt'>(2)                   International
      Disputes: Any dispute arising out of or relating to this Agreement between
      Persons of different nationalities shall be finally settled by binding
      arbitration by one arbitrator in accordance with the International Arbitration
      Rules of the International Centre for Dispute Resolution of the American
      Arbitration Association.  The place of arbitration shall be Houston, Texas,
      United States.  The language of the arbitration shall be English.  Judgment on
      an award may be entered by any court of competent jurisdiction.</span></h2>

      <p class=BodyText>&nbsp;</p>

      </div>

      <span style='font-size:10.0pt;font-family:"Calibri",sans-serif'><br clear=all
      style='page-break-before:auto'>
      </span>

      <div class=Section1>

      <h2 class="Heading2"><span style='font-size:10.0pt;color:#010000'>(n)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><b><span style='font-size:10.0pt; border:solid 1.0pt'>Waiver of Jury Trial</span></b><span
      style='font-size:10.0pt'>. Each party irrevocably and unconditionally waives
      any right it may have to a trial by jury in respect of any legal action arising
      out of or relating to this Agreement or the transactions contemplated hereby<b>.</b><a
      name="co_anchor_a248027_1"></a></span></h2>

      </div>

      <span style='font-size:10.0pt;font-family:"Calibri",sans-serif'><br clear=all
      style='page-break-before:auto'>
      </span>

      <div class=Section1>

      <h2 class="Heading2"><span style='font-size:10.0pt;color:#010000'>(o)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><b><span style='font-size:10.0pt; border:solid 1.0pt'>Compliance with Laws</span></b><span
      style='font-size:10.0pt'>.</span></h2>

      <h3 class="Heading3"><span style='font-size:10.0pt;color:#010000'>(1)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>Notwithstanding anything in this
      Section to the contrary, to the extent that international and national Laws do
      not conflict with the applicable Laws of the United States, Customer shall comply
      with all international and national Laws that apply to the Services and Blade
      Technology Materials.  If any conflict arises between United States Laws and
      any other international and national Laws, Customer will strictly follow United
      States’ Laws. These international and national Laws include, without
      limitation, the United States Foreign Corrupt Practices Act, the United Kingdom
      Bribery Act, the United States Money Laundering Control Act, and the end-user,
      end-use, export, and destination restrictions issued by the United States, Canada,
      European Union, and other governments having jurisdiction over the subject
      matter hereof.  Without limitation on the foregoing, Customer represents and
      warrants that the Services will not be used by, accessed in, shipped,
      transferred, exported, or re-exported to any Person or into any region or country
      into which such use, accessed, shipment, transfer, export, or re-export is
      prohibited by, or used in any manner prohibited by, the export Laws, anti-boycott
      laws, restrictions, or regulations of the United States of America
      (collectively “<b>U.S. Export Laws</b>”).  In addition, to the extent the
      Services or Blade Technology Materials are identified as export-controlled
      under U.S. Export Laws, each party represents and warrants that (a) it is not a
      resident of or otherwise located within any nation or territory identified in
      such Laws as an embargoed nation or territory, (b) is not otherwise prohibited
      under the U.S. Export Laws from receiving, using, accessing, disclosing or
      providing the Services, and (c) does not intend for, and will not knowingly
      allow, the Services to be used by any person whose use of the Services is
      prohibited by the U.S. Export Laws.  All rights herein granted for the use of
      the Services and Blade Technology Materials are subject to and conditioned upon
      compliance at all times with the conditions, representations and warranties in
      this Section and subject to revocation and termination without notice upon
      non-compliance at any time with the terms of this Section.  <b><span
      style='text-transform:uppercase;letter-spacing:1.0pt'>Customer shall indemnify,
      defend, and hold harmless all Blade Technology Indemnitees from and against any
      and all Losses incurred by such Blade Technology Indemnitees resulting from any
      Action by any Person that arises out of or result from any one or more Customer
      Indemnitees or Authorized Users breach of this Section</span>.</b></span></h3>

      <h3 class="Heading3"><span style='font-size:10.0pt;color:#010000'>(2)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>If the Customer is located in a
      country requiring registration of the Services with government authorities, the
      Customer is responsible for meeting all the requirements of registration and
      costs of the Services in that country.</span></h3>

      <h3 class="Heading3"><span style='font-size:10.0pt;color:#010000'>(3)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>The Customer hereby certifies and confirms
      that Customer, all Authorized Users, and all Customer Indemnitees:</span></h3>

      <h4 class="Heading4"><span style='font-size:10.0pt;color:#010000'>(A)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>are not citizens, nationals or
      residents of, and not under the control of, the government of any country or
      region to which the United States has prohibited export of technical
      information, including, without limitation, Cuba, Iran, North Korea, Sudan, Venezuela,
      Syria, and Crimea and will not otherwise use, access in, or otherwise export or
      re-export the Services or Blade Technology Materials, directly or indirectly,
      to any of or in connection with any or those countries, their citizens,
      nationals, or residents;</span></h4>

      <h4 class="Heading4"><span style='font-size:10.0pt;color:#010000'>(B)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>will not use the Services or Blade
      Technology Materials in any situations where the Customer Data is used in
      connection with Cuba, Iran, North Korea, Sudan, Syria, Venezuela, and Crimea or
      in connection with any of those countries’ or regions’ citizens, nationals,
      residents, Persons;</span></h4>

      <h4 class="Heading4"><span style='font-size:10.0pt;color:#010000'>(C)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>are not listed on the United
      States Department of Treasury list of Specially Designated Nationals, Specially
      Designated Terrorists, and Specially Designated Narcotics Traffickers, nor
      listed on the United States Department of Commerce Table of Denial Orders and
      will not use for, access, or otherwise export or re-export the Services or
      Blade Technology Materials, directly or indirectly, to any Person on those
      lists; and</span></h4>

      <h4 class="Heading4"><span style='font-size:10.0pt;color:#010000'>(D)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>will not use or access the
      Services or Blade Technology Materials for, and will not allow the Services or
      Blade Technology Materials to be used or accessed for, any purposes prohibited
      by Law, including, without limitation:</span></h4>

      <h5 class="Heading5"><span style='font-size:10.0pt;color:#010000'>(i)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>for the development, design,
      manufacture or production of nuclear, chemical, or biological weapons of mass
      destruction, or</span></h5>

      <h5 class="Heading5"><span style='font-size:10.0pt;color:#010000'>(ii)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><span style='font-size:10.0pt'>for any project that violates
      Ukraine/Russian-related sanctions.</span></h5>

      <h5 class="Heading5"><span style='font-size:10.0pt'>&nbsp;</span></h5>

      </div>

      <span style='font-size:10.0pt;font-family:"Calibri",sans-serif'><br clear=all
      style='page-break-before:auto'>
      </span>

      <div class=Section3>

      <h2 class="Heading2"><span style='font-size:10.0pt;color:#010000'>(p)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><b><span style='font-size:10.0pt; border:solid 1.0pt'>Foreign Sovereign Immunity</span></b><span
      style='font-size:10.0pt'>.  If Customer, is owned, directly or indirectly, in
      whole or in part by any country or sovereign, or is an employee, contractor, authority,
      or agency of any country or sovereign, <b><span style='text-transform:uppercase;
      letter-spacing:1.0pt'>Customer hereby waives all rights and immunities,
      including without limitation, any immunities from lawsuits, claims, prejudgment
      seizure, arrest, or attachment it may have under the United States Foreign
      Sovereign Immunities Act of 1976, as amended, or any similar type or statute,
      law, rule, or regulation of any country or sovereign</span></b>.</span></h2>

      </div>

      <span style='font-size:10.0pt;font-family:"Calibri",sans-serif'><br clear=all
      style='page-break-before:auto'>
      </span>

      <div class=Section1>

      <h2 class="Heading2"><span style='font-size:10.0pt;color:#010000'>(q)<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;
      </span></span><b><span style='font-size:10.0pt; border:solid 1.0pt'>Equitable Relief</span></b><span
      style='font-size:10.0pt'>. Customer acknowledges that a breach or threatened
      breach by Customer of any of its obligations under Section 3, Section 4(c),or Section
      7(c), Section 9, or Section 15 would cause Blade Technology irreparable harm
      for which monetary damages would not be an adequate remedy and that, in the
      event of such breach or threatened breach, Blade Technology will be entitled to
      equitable relief, including a restraining order, an injunction, specific
      performance, and any other relief that may be available from any court in any
      applicable jurisdiction throughout the world, without any requirement to post a
      bond or other security, or to prove actual damages or that monetary damages are
      not an adequate remedy. Such remedies are not exclusive and are in addition to
      all other remedies that may be available at law, in equity, or otherwise.</span></h2>

      <p class=BodyText><span style='font-size:9.0pt;line-height:115%'>The above
      Agreement is a mutually agreed upon between the parties.</span></p>

      </div>

      <span style='font-size:10.0pt;font-family:"Calibri",sans-serif'><br clear=all
      style='page-break-before:always'>
      </span>

      <div class=Section1>

      <p class=Normal align=center style='text-align:center;line-height:normal'><b><span
      style='font-size:12.0pt;letter-spacing:1.0pt'>EXHIBIT A</span></b></p>

      <p class=Normal align=center style='text-align:center;line-height:normal'><b><span
      style='font-size:10.0pt;letter-spacing:1.0pt'>SERVICES</span></b><a
      name="co_anchor_a1063361_1"></a></p>

      <table class=TableGrid border=1 cellspacing=0 cellpadding=0 width="101%"
      style='width:101.42%;border-collapse:collapse;border:none'>
      <tr>
        <td width="100%" colspan=4 valign=top style='width:100.0%;border:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal align=center style='margin-bottom:0in;margin-bottom:.0001pt;
        text-align:center;line-height:normal'><a name="_Hlk56084307"><b>StrinGnosis
        SaaS Features</b></a></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><b><span style='font-size:8.0pt'>Features</span></b></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><b><span style='font-size:8.0pt'>Standard</span></b></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><b><span style='font-size:8.0pt'>Advanced</span></b></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><b><span style='font-size:8.0pt'>Comments</span></b></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Advanced, Intuitive, Multi-Window GUI</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Easy to use interface with intuitive
        controls and capabilities</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Working Stress Design (Level 2)</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>API ratings and triaxial VME checks</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Connection Design Checks</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Use connection ratings and efficiency
        provided by manufacturers</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Customizable Equipment Database</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Allows proprietary tubulars and
        connections.  Searchable and editable</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>SideKick</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Quick calculations, customizable,
        “always on” well schematic window</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Minimum Safety Factor Summary Tables
        and Bar Charts</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Unique summary tables and charts, in
        addition to detailed results</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Standard Loads</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Commonly used standard casing and
        tubing design load templates</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Custom Loads</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Allows custom definition of loads. 
        Allow use of standard templates as starting point.</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Thermal Simulation</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Production, and injection, circulation
        and worse case discharge thermal analysis</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Custom Report Generator</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>User-specified reports</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Completion Design</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Tailored for completion design with
        completion equipment</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Editable fluids database</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Ability to create and modify wellbore
        fluids for more complex operations</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Worst Case Discharge / Well Containment</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>&nbsp;</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Per U.S. BSEE (Levels 1 &amp; 42 Burst
        and Collapse) Screening Requirements</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Brittle Failure Limit</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>&nbsp;</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Uses ISO TR 10400 (API TR 5C3) Level 2
        Brittle Burst Failure Assessment Diagram</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Limit State Design (LSD) (Level 3)</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>&nbsp;</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Deterministic LSD for tension-burst and
        brittle burst. Collapse limit state in RBD</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Probabilistic Strength</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>&nbsp;</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Includes ISO TR 10400 data. Allows user
        defined strength distributions</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Reliability Based Design (RBD) (Level
        4)</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>&nbsp;</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Both failure and exceedance (yielding)
        probabilities. Includes RBD graphs and summary tables</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Annular Pressure Buildup (APB)</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>&nbsp;</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Analysis of multiple APB cases and
        calculations of allowable APB</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Design of anisotropic materials</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>&nbsp;</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>For analysis and design of CRA and
        other anisotropic tubulars</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Allowable APB</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>&nbsp;</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Determines allowable APB in all annuli
        for a specific well condition</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Wellhead Movement</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>&nbsp;</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Multi-String wellhead movement and
        forces analysis, pile capacity, soil interaction</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Design of Anisotropic Materials</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>&nbsp;</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>For analysis and design of CRA and
        other anisotropic tubulars</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Standard Load Template Customization</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>&nbsp;</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Available upon request for buyers of
        10+ user seats</span></p>
        </td>
      </tr>
      <tr>
        <td width="30%" valign=top style='width:30.02%;border:solid windowtext 1.0pt;
        border-top:none;padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>Triaxial Connection Checks</span></p>
        </td>
        <td width="9%" valign=top style='width:9.44%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>&nbsp;</span></p>
        </td>
        <td width="10%" valign=top style='width:10.02%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>X</span></p>
        </td>
        <td width="50%" valign=top style='width:50.52%;border-top:none;border-left:
        none;border-bottom:solid windowtext 1.0pt;border-right:solid windowtext 1.0pt;
        padding:0in 5.4pt 0in 5.4pt'>
        <p class=Normal style='margin-bottom:0in;margin-bottom:.0001pt;line-height:
        normal'><span style='font-size:8.0pt'>StringNexus, Available add-on upon
        request</span></p>
        </td>
      </tr>
      </table>

      <p class=Normal style='line-height:normal'>&nbsp;</p>

      </div>
      <!-- license agreemnet html content ends here -->
      <form @submit.stop.prevent="handleSubmit">
      </form>
    </div>

    <div slot="modal-footer" class="w-100" v-if="this.userAction === 'Accept'">
      <b-btn size="sm" class="btn btn-lg btn-blade btn-block" @click="acceptagreement">Accept</b-btn>
      <b-btn size="sm" class="btn btn-lg btn-blade btn-block" @click="dismissAgreememt">Reject</b-btn>
    </div>
    <div slot="modal-footer" class="w-100" v-else>
      <b-btn size="sm" class="btn btn-lg btn-blade btn-block" @click="dismissAgreememt">OK</b-btn>
    </div>

    <a href="./static/files/StrinGnosisSaaSAgreement.pdf" class="btn" v-b-tooltip title="Download StrinGnosis Software as a Service User Agreement" download>
        <font-awesome-layers class="fa-fw fa-3x">
          <font-awesome-icon icon="file-pdf" class="blade-blue"/>
        </font-awesome-layers>
      </a>

  </b-modal>
</template>

<script lang="js">
var pdf = require('../assets/StrinGnosisSaaSAgreement.pdf')
export default {
  name: 'license-agreement',
  props: [],
  mounted () {
    var self = this
    self.$eventBus.$on('show-license-agreement', (action, parent) => {
      this.userAction = action
      this.parentName = parent
      self.$refs.licenseagreement.show()
    })
  },
  computed: {

    canAccept () {
      return this.accepted
    }
  },
  data () {
    return {
      accepted: false,
      userAction: '',
      parentName: ''
    }
  },
  methods: {

    acceptagreement () {
      this.$refs.licenseagreement.hide()
      if (this.parentName === 'cp') {
        this.$eventBus.$emit('license-agreement-accepted-cp')
      } else if (this.parentName === 'cdu') {
        this.$eventBus.$emit('license-agreement-accepted-cdu')
      } else {
        this.$eventBus.$emit('license-agreement-accepted')
      }
    },

    dismissAgreememt () {
      this.$refs.licenseagreement.hide()
      this.$eventBus.$emit('license-agreement-dismissed')
    }

  }
}
</script>

<style scoped lang="scss">
textarea {
    resize: none;
}
</style>



// WEBPACK FOOTER //
// src/components/LicenseAgreement.vue